import { getProxyUrl } from '.'
import { addOptionsAuth } from './auth'
import { API } from '@utils/queryBuilder'
import {
  isFroAllowedFinish,
  PORCELANICAS_12_ACABADO,
} from '@utils/sceneObjects/frontals/frontalRuns'

export async function fetchPorcelanicas12FrontalTextures(linkedTextureID: number): Promise<any[]> {
  if (!Number.isFinite(linkedTextureID) || linkedTextureID <= 0) return []
  const info = await API().api.acabadosGetAcabadoZonaModeloAcabadoInfo(linkedTextureID)
  const zonas = ((info as { data?: any[] })?.data as any[]) || []
  const allAcabados = (zonas?.[0]?.acabados || []).filter((acabado: any) =>
    isFroAllowedFinish(acabado?.acabado),
  )
  const allTextures: any[] = []
  for (const acabado of allAcabados) {
    const idAcabado = acabado.idAcabadoUnidadModeloAcabado || acabado.idAcabadoUnidad
    if (!idAcabado) continue
    try {
      const texResp = await API().api.acabadosGetTexturas(idAcabado)
      const textures = ((texResp as { data?: any[] })?.data as any[]) || []
      textures.forEach((tex) => {
        const exists = allTextures.some(
          (entry) => entry?.nombre === tex?.nombre || entry?.descripcion === tex?.descripcion,
        )
        if (!exists) {
          allTextures.push({
            ...tex,
            acabado: acabado?.acabado ?? PORCELANICAS_12_ACABADO,
          })
        }
      })
    } catch {
      /* textura opcional */
    }
  }
  return allTextures
}

export async function getEncimerasFrontales(): Promise<Record<string, string>> {
  const url = getProxyUrl('api/acabados/getencimerasfrontales')

  const params: RequestInit = addOptionsAuth({
    method: 'GET',
    mode: 'cors',
    headers: {
      'Accept-Language': 'ES',
      'Content-Type': 'application/json',
    },
  })

  try {
    const response = await fetch(url, params)
    if (response.ok) {
      const data = await response.json()
      return data as Record<string, string>
    } else {
      console.error('Error en getEncimerasFrontales:', response.status, response.statusText)
      return {}
    }
  } catch (error) {
    console.error('Error en getEncimerasFrontales:', error)
    return {}
  }
}
